import { Icon, Text, Tooltip, HStack } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';
import { useSetRecoilState } from 'recoil';

import { blockReasonModalState } from '../../../../../../../store/customer/atom';
import { CustomerBlockReasonModal } from '../../../../../../../store/customer/types';

namespace CustomerBlockStatusTypes {
  export type Props = {
    customer: CustomerBlockReasonModal;
  };

  export type WrapperProps = { children: React.ReactNode; blocked?: boolean; onPress?: () => void };
}

const Wrapper: React.FC<CustomerBlockStatusTypes.WrapperProps> = ({
  children,
  blocked,
  onPress,
}) => {
  return blocked ? (
    <Pressable onPress={onPress}>{children}</Pressable>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export const CustomerBlockStatus: React.FC<CustomerBlockStatusTypes.Props> = ({ customer }) => {
  const setModalState = useSetRecoilState(blockReasonModalState);

  const handlePress = () => {
    setModalState({ isOpen: true, customer });
  };

  const statusIcon = (
    <Icon
      name={customer.registrationBlocked ? 'Info' : 'Check'}
      size="xxs"
      variant={customer.registrationBlocked ? undefined : 'rounded-border'}
      borderColor="feedback.success.default"
      color={customer.registrationBlocked ? 'feedback.error.default' : 'feedback.success.default'}
    />
  );

  return (
    <Wrapper blocked={customer.registrationBlocked} onPress={handlePress}>
      <HStack alignItems="center" space="stack.quarck">
        <Text color={customer.registrationBlocked ? 'feedback.error.default' : undefined}>
          {customer.registrationStatusName}
        </Text>
        {customer.registrationBlocked ? (
          <Tooltip label="Clique para ver os motivos do bloqueio">
            <Box>{statusIcon}</Box>
          </Tooltip>
        ) : (
          statusIcon
        )}
      </HStack>
    </Wrapper>
  );
};
